/**
 * Local/dev-only quick-login accounts shown under the reader login box.
 * Keep in sync with apps/web/src/lib/dev-login-accounts.ts.
 */

export type DevLoginAccount =
  | {
      id: string;
      kind: "otp";
      label: string;
      orgName: string;
      phone: string;
      organizationSlug?: string;
    }
  | {
      id: string;
      kind: "email";
      label: string;
      orgName: string;
      email: string;
      password: string;
    };

export const DEV_LOGIN_ACCOUNTS: DevLoginAccount[] = [
  {
    id: "ameli-admin",
    kind: "email",
    label: "مدیر سازمان",
    orgName: "شرکت مدافعان فناوری حامی",
    email: "admin@ameli.demo",
    password: "Passw0rd!",
  },
  {
    id: "ameli-director",
    kind: "email",
    label: "مدیر حقوقی",
    orgName: "شرکت مدافعان فناوری حامی",
    email: "director@ameli.demo",
    password: "Passw0rd!",
  },
  {
    id: "ameli-lawyer",
    kind: "email",
    label: "وکیل",
    orgName: "شرکت مدافعان فناوری حامی",
    email: "lawyer@ameli.demo",
    password: "Passw0rd!",
  },
  {
    id: "ameli-requester",
    kind: "otp",
    label: "درخواست‌دهنده",
    orgName: "شرکت مدافعان فناوری حامی",
    phone: "09121234567",
    organizationSlug: "ameli-law",
  },
  {
    id: "bluebank-admin",
    kind: "otp",
    label: "مدیر سازمان",
    orgName: "شرکت نویساین",
    phone: "09120000001",
    organizationSlug: "bluebank",
  },
  {
    id: "bluebank-banker",
    kind: "otp",
    label: "بانکدار ثابت",
    orgName: "شرکت نویساین",
    phone: "09120000002",
    organizationSlug: "bluebank",
  },
  {
    id: "bluebank-deputy",
    kind: "otp",
    label: "معاون کسب‌وکار",
    orgName: "شرکت نویساین",
    phone: "09120000003",
    organizationSlug: "bluebank",
  },
];
